module.exports = __webpack_public_path__ + "img/bi_order_app_v.d2d8969a.png";